import React, { useEffect, useRef, useState } from "react";
import { Box, Divider, Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import InputTcDetails from "./product-details/input-tc-details";
import CombinedProductDetails from "./product-details/combined-product-details";
import RawMaterialDetails from "./product-details/raw-material-details";
import { StyledButton } from "../../../../../shared/components/buttons/custom-button";
import CustomTable from "../../../../../shared/components/table/custom-table";
import { ActionsMenu } from "../../../../../shared/components/table/custom-actions";
import ActionsModalPopup, {
  ActionButtonConfig,
} from "../../../../../shared/components/modals/action-popup";
import CustomStepper from "../../../../../shared/components/stepper/steppers";
import { ITcProductRawMaterialInformation } from "../../../tc-models/tc-req-dto/tc-certified-product-details.req_dto";
import {
  IInputTcDetails,
  IInputTcProductStandardDetails,
  OCSFirstProcessorData,
} from "../../../tc-models/tc-req-dto/input-tc-product.req_dto";
import InputTcProductStandardDetails from "./product-details/input-tc-product-standard-details";
import OcsProcessor from "./product-details/input-tc-ocs-processor";
import SampleRowSelectionDemo from "./product-details/sample-row-selection-demo";
import InputCertifiedRawMaterialDetails from "./product-details/input-certified-raw-material-details";
import {
  FloatingButtonContainer,
  InnerButton,
} from "../../../../../shared/components/buttons/floating-button-container";
import {
  mapPayload,
  reverseMapPayload,
} from "../../payload/input-tc-products-payload";
import { transactionCertificateService } from "../../../tc-service/transaction-certificate.service";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { useFormActions } from "../../../../../shared/hooks/form-builder.hooks";
import useNotification from "../../../../../shared/hooks/useNotification";
import { useApi } from "../../../../../shared/hooks/useApi";
import { LoaderComponent } from "../../../../../shared/components/loaders/page-loader";
import {
  DELETECONFIG,
  TC_CREATE_ROUTE_CONFIG,
  TCAppConfig,
} from "../../../../../shared/app-configs/tc-app-configs";
import _, { forEach, isEmpty } from "lodash";
import AlertPopup from "../../../../../shared/components/modals/alert-moadal";
import { useTransactionCertificateStore } from "../../../../../store/transaction-certificates.store";
import { Utills } from "../../../../../shared/app-configs/utilit";
import RenderDetailPanel from "./render-detail-panel";
import {
  mapInputTcDataToPostPayload,
  mapPostPayloadToInputTcData,
} from "./input-products.models";
import {
  fetchProductComponentDetails,
  getProductShipmentDataByProductNo,
} from "./input-product-apis";
import { Pagination } from "../../../../../shared/hooks/useRecordStore";

interface InputTcProductDetailProps {
  onNextTab: () => Promise<void>;
}

const InputTcProductDetail: React.FC<InputTcProductDetailProps> = ({
  onNextTab,
}) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const { loading, error, executeGet, executeDelete, executePost } = useApi();
  const { executeGet: executeATCGet } = useApi();
  const { executeGet: executeProduct } = useApi();
  const { executeGet: executeProductData } = useApi();
  const [data, setData] = useState<any[]>([]);
  const [apiData, setAPIData] = useState<any[]>([]);
  const [tableData, setTableData] = useState<any[]>([]);
  const [productId, setProductId] = useState<string | null>(null);
  const [shipmentId, setShipmentId] = useState<string>();
  const [inputTcId, setInputTcId] = useState<string>();
  const [productData, setProductData] = useState<any[]>([]);
  const [allProducts, setAllProducts] = useState<any[]>([]);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const { TE_ID, formtype } = useParams<string>();
  const [pendingSave, setPendingSave] = useState<any>(null);
  const hasCreateTc: boolean = formtype === "create-tc";
  const hasSubmitTC: boolean = formtype === "submited-tc";
  const [isNextEnabled, setNextEnabled] = useState<boolean>(false);
  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });
  const [rowCount, setRowCount] = useState<number>(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const [popUpTitle, setPopUpTitle] = useState<string>("");
  const [popUpBtnName, setPopUpBtnName] = useState<string>("");
  const [isDeleteOnly, setDeleteOnly] = useState(false);
  const [isValueChanged, setIsValueChanged] = useState<boolean>(false);
  const { isRestrictPopUpSave, setRestrictPopUpSave } =
    useTransactionCertificateStore();
  const [getEditExistingShipment, setEditExistingShipment] = useState({
    index: -1,
    value: "",
  });
  const [selectedInputTcId, setSelectedInputTcId] = useState<string>("");
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const [isTC, setIsTC] = useState<boolean | null>(null); // Flag to track TC vs ATC usage (null = not selected, true = TC, false = ATC)
  const [certifiedRawMaterialCodes, setCertifiedRawMaterialCodes] = useState<any[]>([]);
  
  // Fetch certified raw material codes on component mount
  useEffect(() => {
    const fetchCertifiedRawMaterialCodes = async () => {
      try {
        const response: any = await executeGet(TCAppConfig.GET_CERTIFIED_RAW_MATERIAL_CODES);
        const raw = response?.data;
        const list = Array.isArray(raw)
          ? raw
          : Array.isArray(raw?.data)
            ? raw.data
            : [];
        setCertifiedRawMaterialCodes(list);
      } catch (err) {
        console.error("Failed to fetch certified raw material codes:", err);
      }
    };

    fetchCertifiedRawMaterialCodes();
  }, []);
  
  // API call to fetch ATC details
  const fetchATCDetails = async (atcId: string) => {
    // Don't call ATC-related APIs if TC is selected
    if (isTC === true) {
      return;
    }
    
    try {
      const response: any = await executeATCGet(
        TCAppConfig.GET_ATC_DETAILS,
        { atcId: atcId }
      );
      
      if (response.data) {
        // Parse the response field which contains a JSON string
        let atcData = response.data;
        if (response.data.response && typeof response.data.response === 'string') {
          atcData = JSON.parse(response.data.response);
        }
        
        // Note: Seller details are now handled in input-tc-details.tsx component
        // via fetchSellerDetailsByAtcId function
        
        // Set product information for ATC source: do not map units/metrics as the ATC API response does not include reliable values for these fields.
        const mappedProducts = atcData.productInformation?.map((product: any, index: number) => ({
          id: `atc-product-${index}`,
          productId: `atc-product-${index}`,
          inputTcProductNo: product.atcProductNo || "",
          inputTcProductArticleNo: "",
          inputTcProductNumberOfUnits: null,
          inputTcProductUnitsMetric: "",
          inputTcProductProductionDate: "",
          inputTcProductCategoryCode: product.atcProductCategoryCode || "",
          inputTcProductCategoryUserSpecificTerm: "",
          inputTcProductDetailCode: product.atcProductDetailCode || "",
          inputTcProductDetailUserSpecificTerm: "",
          inputTcProductInfoTrimsExcluded: "",
          inputTcProductInfoAssociatedTc: "",
          inputTcProductInfoFiberLength: "",
          inputTcProductInfoYarnCount: "",
          inputTcProductInfoFabricWeightAndConstruct: "",
          inputTcProductInfoFabricWeightOfFinishedProduct: "",
          inputTcProductInfoAdditional: "",
        })) || [];
        
        setAllProducts(mappedProducts);
        setSelectedProductIds(mappedProducts.map((p: any) => p.productId));
        
        // Set raw material information
        const mappedRawMaterials = atcData.rawMaterialInformation?.map((rawMaterial: any, index: number) => ({
          tcProductNo: rawMaterial.associatedProductNo || "",
          tcProductRawMaterialOrder: index + 1,
          tcProductRawMaterialCode: rawMaterial.rawMaterialCode || "",
          tcProductRawMaterialPercentage: rawMaterial.rawMaterialCompostion || "",
        })) || [];
        
        // Set standard details information from rawMaterialInformation + certified mapping
        // Step 1: Build mapping material_code -> [standards]
        const rmCodeToStandardsMap: Record<string, string[]> = {};
        (certifiedRawMaterialCodes || []).forEach((item: any) => {
          const code = item.material_code || item.materialCode || item.rmCode;
          const standards = (item.standard || "")
            .split("/")
            .map((s: string) => s.trim())
            .filter(Boolean);
          if (code && standards.length > 0) {
            rmCodeToStandardsMap[code] = standards;
          }
        });

        // Step 2: Build map standard -> [weights] from rawMaterialInformation
        const standardToWeightsMap: Record<string, number[]> = {};
        (atcData.rawMaterialInformation || []).forEach((raw: any) => {
          const rmCode = raw.rawMaterialCode;
          const weight = Number(raw.rawMaterialWeight) || 0;

          if (rmCode && rmCodeToStandardsMap[rmCode]) {
            const standards = rmCodeToStandardsMap[rmCode];

            standards.forEach((std: string) => {
              const stdUpper = (std || "").toUpperCase();

              // Check if standard is in atcStandard and not GOTS
              const isInAtcStandard = (atcData.atcStandard || []).some(
                (s: string) => (s || "").toUpperCase() === stdUpper
              );

              if (isInAtcStandard && stdUpper !== "GOTS") {
                if (!standardToWeightsMap[std]) {
                  standardToWeightsMap[std] = [];
                }
                standardToWeightsMap[std].push(weight);
              }
            });
          }
        });

        // Step 3: Build mappedStandardDetails from aggregated weights
        const mappedStandardDetails: IInputTcProductStandardDetails[] = Object.entries(
          standardToWeightsMap
        ).map(([standard, weights]) => ({
          productNo: mappedProducts[0]?.inputTcProductNo || "",
          standard,
          standardLabelGrade: "",
          certifiedWeight: weights.reduce((a, b) => a + b, 0).toString(),
          certifiedWeightUsed: "",
        })) || [];
        
        // Save all data to stepData for persistence across navigation
        setStepData(prev => ({
          ...prev,
          combinedProductDetails: {
            inputTcProductNo: "",
            products: mappedProducts,
            selectedProductIds: mappedProducts.map((p: any) => p.productId)
          },
          rawMaterialDetails: mappedRawMaterials,
          inputTcProductStandardDetails: mappedStandardDetails
        }));
        
      }
    } catch (err) {
      console.error("Failed to fetch ATC details:", err);
    }
  };
  
  const fetchInputTcProductDetails = async () => {
    try {
      const response: any = await executeGet(
        TCAppConfig.GET_INPUT_TC_PRODUCTDETAILS_INFO,
        { 
          tcId: TE_ID,
          limit: pagination?.pageSize,
          offset: pagination?.pageIndex * pagination?.pageSize
        }
      );
      const result = response.data;
      setTableData(result.response);
      setAPIData(result.data);
      setRowCount(response?.data?.no_of_records);
      setNextEnabled(true);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };
  const shipmentFormData = async () => {
    try {
      const response = await executeProduct(
        TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST,
        { tcId: TE_ID }
      );
      setProductData(response?.data.response);
    } catch (err) {
      console.error("Failed to fetch TC Base Details:", err);
    }
  };

  // API call to fetch all available products
  const fetchAllProducts = async (tcId?: string) => {
    const idToUse = tcId || selectedInputTcId || TE_ID;
    if (!idToUse) {
      console.warn('fetchAllProducts: tcId not available');
      return { data: { response: [] } };
    }

    try {
      const response = await executeProductData(TCAppConfig.GET_PRODUCT_RAWMATERIAL_INFO_LIST, {
        tcId: idToUse 
      });
      
      return response;
    } catch (err) {
      console.error('Error fetching product data:', err);
      throw err;
    }
  };


  // Map API response to CombinedProductData format
  const mapApiResponseToTableData = (apiResponse: any): any[] => {
    const responseData = apiResponse?.data?.response || [];
    
    return responseData.map((item: any, index: number) => ({
      id: item.productId || `product-${index}`,
      productId: item.productId || `product-${index}`,
      inputTcProductNo: item.tcProductNo || '',
      inputTcProductArticleNo: item.tcProductArticleNo || '',
      inputTcProductNumberOfUnits: item.tcProductNumberOfUnits || null,
      inputTcProductUnitsMetric: item.tcProductUnitsMetric || '',
      inputTcProductProductionDate: item.tcProductProductionDate || '',
      inputTcProductCategoryCode: item.tcProductCategoryCode || '',
      inputTcProductCategoryUserSpecificTerm: '',
      inputTcProductDetailCode: '',
      inputTcProductDetailUserSpecificTerm: '',
      inputTcProductInfoTrimsExcluded: '',
      inputTcProductInfoAssociatedTc: item.tcProductInfoAssociatedTc || '',
      inputTcProductInfoFiberLength: '',
      inputTcProductInfoYarnCount: '',
      inputTcProductInfoFabricWeightAndConstruct: item.tcNetShippingWeight ? `${item.tcNetShippingWeight}kg` : '',
      inputTcProductInfoFabricWeightOfFinishedProduct: item.tcProductSupplementaryWeight ? `${item.tcProductSupplementaryWeight}kg` : '',
      inputTcProductInfoAdditional: `Shipment: ${item.tcProductShipmentNo?.[0] || ''}, Order: ${item.tcProductOrderNo?.[0] || ''}`,
    }));
  };

  // Merge API data with stepData (replace API products with stepData products where productId matches)
  const mergeProductData = (apiProducts: any[], stepDataProducts: any[]): any[] => {
    return apiProducts.map((apiProduct: any) => {
      const stepDataProduct = stepDataProducts.find((stepProduct: any) => stepProduct.productId === apiProduct.productId);
      return stepDataProduct || apiProduct;
    });
  };
  const [editingIndex, setEditingIndex] = useState<number>(-1);
  const {
    getCurrentFormValues,
    getCurrentTableData,
    updateTableData,
    updateTableRowbyIndex,
    removeTableRowbyIndex,
    updateField,
    resetFormValueByPage,
    setDeleteSave,
    replaceTableDatas,
    getDeleteSave,
    setEditSave,
  } = useFormActions("input-tc-product-details");
  const initInputTcDetails: IInputTcDetails = {
    inputTcNo: "",
    inputAtcNo: "",
    inputTcCBName: "",
    inputTcSellerLicenseNo: "",
    inputTcSellerScNo: "",
    inputTcSellerTeId: "",
    inputTcUsdaCompliantFlag: "",
    tcAssociatedProductNo: "",
    InputCBLicensingCode: "",
    inputTCFlag: "Y",
  };

  const initInputTcProductDetails = {
    inputTcProductNo: "",
    inputTcProductArticleNo: "",
    inputTcProductNumberOfUnits: null,
    inputTcProductUnitsMetric: "",
    inputTcProductProductionDate: "",
    inputTcProductCategoryCode: "",
    inputTcProductCategoryUserSpecificTerm: "",
    inputTcProductDetailCode: "",
    inputTcProductDetailUserSpecificTerm: "",
  };

  const initInputTcProductAdditionalDetails = {
    inputTcProductInfoTrimsExcluded: "",
    inputTcProductInfoAssociatedTc: "",
    inputTcProductInfoFiberLength: "",
    inputTcProductInfoYarnCount: "",
    inputTcProductInfoFabricWeightAndConstruct: "",
    inputTcProductInfoFabricWeightOfFinishedProduct: "",
    inputTcProductInfoAdditional: "",
  };
  const initocsProcessorConfig: OCSFirstProcessorData = {
    inputTcOCSFirstProcessor: "Y",
    tableData: [],
  };
  const initInputTcProductStandardDetails: IInputTcProductStandardDetails[] =
    [];
  const initRawMaterialInfo: ITcProductRawMaterialInformation[] = [];
  const initCertifiedRawMaterialDetails: any[] = [];

  const [stepData, setStepData] = useState({
    inputTcDetails: initInputTcDetails,
    ocsProcessorConfig: initocsProcessorConfig,
    combinedProductDetails: {
      inputTcProductNo: "",
      products: [] as any[],
      selectedProductIds: [] as string[]
    },
    inputTcProductStandardDetails: initInputTcProductStandardDetails,
    rawMaterialDetails: initRawMaterialInfo,
    certifiedRawMaterialDetails: initCertifiedRawMaterialDetails,
  });
  const toggleDrawer = () => {
    setActiveStep(0);
    if (drawerOpen) {
      setStepData({
        inputTcDetails: initInputTcDetails,
        combinedProductDetails: {
          inputTcProductNo: "",
          products: [],
          selectedProductIds: []
        },
        inputTcProductStandardDetails: initInputTcProductStandardDetails,
        rawMaterialDetails: initRawMaterialInfo,
        certifiedRawMaterialDetails: initCertifiedRawMaterialDetails,
        ocsProcessorConfig: initocsProcessorConfig,
      });
      setProductId(null);
      setShipmentId("");
      setInputTcId("");
      setEditingIndex(-1);
      setZustandInitialState();
      setPendingSave(null);
      setIsValueChanged(false);
      // Reset isTC flag when closing drawer
      setIsTC(null);
      setSelectedInputTcId("");
      setSelectedProductIds([]);
    }
    setRestrictPopUpSave(false);
    setDrawerOpen((prev) => !prev);
  };

  const handleConfirmSave = async () => {
    try {
      // If we have a pending save payload, save it first
      if (pendingSave) {
        delete pendingSave.inputTcId;
        await handleSave(pendingSave);
        setPendingSave(null); // Clear the pending save
      }

      // Then delete the existing record
      await executeDelete(`${TCAppConfig.TC_DELETE_API}`, {
        pageName: DELETECONFIG.inputTc,
        tcId: TE_ID,
        inputTcId: inputTcId,
        shipmentId: shipmentId,
        productId: productId,
      });

      // Close the dialog
      setDialogOpen(false);
      fetchInputTcProductDetails();
      // Reset states
      setInputTcId("");
      setShipmentId("");
      setProductId("");

      notify("Successfully processed", "success");
    } catch (error) {
      console.error("Error in handleConfirmSave:", error);
      notify("Failed to process the request", "error");
    }
  };

  const handleDeleteSaveData = async () => {
    // Perform API call to save form data here
    try {
      if (TE_ID) {
        if (!isDeleteOnly && getDeleteSave()) {
          const userFilledValues = getCurrentFormValues();
          updateTableRowbyIndex(editingIndex, userFilledValues);
        } else if (isDeleteOnly && !getDeleteSave()) {
          removeTableRowbyIndex(editingIndex);
          const deletedData = data.filter((item, index) => {
            index !== editingIndex;
          });
          setData(deletedData);
          setEditingIndex(-1);
        }
        const tcProductDetailsData = getCurrentTableData();
        setDeleteSave(false);
        setEditSave(false);
        const payload: any = mapPayload(tcProductDetailsData, TE_ID);
        const result: any = await executePost(
          TCAppConfig.INPUT_TCPRODUCT_DETAILS_ENDPOINT,
          payload
        );
        if (result.status == 200) {
          notify("Saved Succesfully", "success");
          if (!isDeleteOnly) toggleDrawer();

          setDeleteOnly(false);
          replaceTableDatas([]);
          await fetchInputTcProductDetails();
        } else {
          notify("Unable to Save", "error");
        }
      }
    } catch (error) {
      console.error("Error saving Transaction Certificate:", error);
    }
  };
  const setZustandInitialState = (initialState?: any) => {
    const defalutState: any = {
      tcAssociatedProductNo: "",
      inputTcNo: "",
      inputTcSellerLicenseNo: "",
      inputTcSellerScNo: "",
      inputTcSellerTeId: "",
      inputTcUsdaCompliantFlag: "",

      "input-tc-ocs-processor": [
        {
          inputFarmSCNo: "",
          inputFarmTCNo: "",
          inputTraderTCNoForOrganicMaterial: "",
          inputTCOrganicFarmStandards: "",
          tcProductRawMaterialOrder: 0,
        },
        {
          inputFarmSCNo: "",
          inputFarmTCNo: "",
          inputTraderTCNoForOrganicMaterial: "",
          inputTCOrganicFarmStandards: "",
          tcProductRawMaterialOrder: 0,
        },
      ],
      inputTcProductNo: "",
      inputTcProductArticleNo: "",
      inputTcProductNumberOfUnits: null,
      inputTcProductUnitsMetric: "",
      inputTcProductProductionDate: "",
      inputTcProductCategoryCode: "",
      inputTcProductCategoryUserSpecificTerm: "",
      inputTcProductDetailCode: "",
      inputTcProductDetailUserSpecificTerm: "",
      inputTcProductInfoTrimsExcluded: "",
      inputTcProductInfoAssociatedTc: "",
      inputTcProductInfoFiberLength: "",
      inputTcProductInfoYarnCount: "",
      inputTcProductInfoFabricWeightAndConstruct: "",
      inputTcProductInfoFabricWeightOfFinishedProduct: "",
      inputTcProductInfoAdditional: "",
      "tc-std-info": [
        {
          standardLabelGrade: "",
          certifiedWeight: 0,
          certifiedWeightUsed: 0,
        },
      ],
      "raw-materials-info": [
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: 0,
        },
        {
          tcProductRawMaterialOrder: 0,
          tcProductRawMaterialCode: "",
          tcProductRawMaterialPercentage: 0,
        },
      ],
    };

    //set zustand state inital values
    Object.entries(initialState ?? defalutState).forEach(([key, value]) => {
      updateField(key, value);
    });
  };

  useEffect(() => {
    setZustandInitialState(null);
    const componentDetailsData = getCurrentTableData();
    if (componentDetailsData) {
      setData(componentDetailsData);
    }
    if (TE_ID) {
      fetchInputTcProductDetails();
      shipmentFormData();
    } else {
      // TO DO Port Changes
      updateTableData([]);
    }
    // TO DO Port Changes
    setRestrictPopUpSave(false);
    resetFormValueByPage();
    setZustandInitialState(null);
  }, [TE_ID, pagination?.pageIndex]);

  // Load product data for combined product details (only for new entries)
  useEffect(() => {
    const loadProductData = async () => {
      // First, check if products already exist in stepData (from previous navigation)
      if (stepData.combinedProductDetails.products && stepData.combinedProductDetails.products.length > 0) {
        // Restore products from stepData
        setAllProducts(stepData.combinedProductDetails.products);
        setSelectedProductIds(stepData.combinedProductDetails.selectedProductIds);
        return;
      }
      
      // Only load if we have a selectedInputTcId
      if (!selectedInputTcId) {
        return;
      }

      try {
        // For TC (isTC === true): fetch TC products
        if (isTC === true) {
          const apiResponse = await fetchAllProducts(selectedInputTcId);
          const apiProducts = mapApiResponseToTableData(apiResponse);
          setAllProducts(apiProducts);
          setSelectedProductIds([]);
          
          // Save to stepData for persistence
          setStepData(prev => ({
            ...prev,
            combinedProductDetails: {
              inputTcProductNo: "",
              products: apiProducts,
              selectedProductIds: []
            }
          }));
        }
        // For ATC (isTC === false): products are already fetched via fetchATCDetails
        // No additional action needed here
      } catch (err) {
        console.error('Error loading product data:', err);
        // Fallback to empty arrays if API fails
        setAllProducts([]);
        setSelectedProductIds([]);
      }
    };

    loadProductData();
  }, [selectedInputTcId, isTC]);
  const handleDataUpdate = (stepKey: string, updatedData: any) => {
    setStepData((prev) => {
      const newStepData = {
        ...prev,
        [stepKey]: updatedData,
      };
      
      // If inputTcDetails flag changed to "N" (TC/ATC not applicable), clear downstream data
      if (stepKey === "inputTcDetails" && updatedData.inputTCFlag === "N") {
        newStepData.inputTcProductStandardDetails = [];
        newStepData.rawMaterialDetails = [];
        newStepData.certifiedRawMaterialDetails = [];
        newStepData.combinedProductDetails = {
          inputTcProductNo: "",
          products: [],
          selectedProductIds: []
        };
        setSelectedProductIds([]);
        setAllProducts([]);
      }
      
      return newStepData;
    });
  };

  // Handle tcId selection from InputTcDetails component
  const handleTcIdSelection = (tcId: string) => {
    setSelectedInputTcId(tcId);
    
    if (tcId === "") {
      // TC field cleared - reset flag and clear products
      setIsTC(null);
      setAllProducts([]);
      setSelectedProductIds([]);
      // Clear product details from stepData
      setStepData((prev) => ({
        ...prev,
        combinedProductDetails: {
          inputTcProductNo: "",
          products: [],
          selectedProductIds: []
        }
      }));
    } else {
      // TC selected - set flag to true
      setIsTC(true);
      // Fetch all products for TC
      fetchAllProducts(tcId);
    }
    
    // Update stepData with the selected tcId
    setStepData((prev) => {
      const updatedData = {
        ...prev,
        inputTcDetails: {
          ...prev.inputTcDetails,
          selectedInputTcId: tcId
        }
      };
      return updatedData;
    });
  };

  // Handle atcId selection from InputTcDetails component
  const handleAtcIdSelection = (atcId: string) => {
    setSelectedInputTcId(atcId);
    
    if (atcId === "") {
      // ATC field cleared - reset flag and clear products
      setIsTC(null);
      setAllProducts([]);
      setSelectedProductIds([]);
      // Clear product details from stepData
      setStepData((prev) => ({
        ...prev,
        combinedProductDetails: {
          inputTcProductNo: "",
          products: [],
          selectedProductIds: []
        }
      }));
    } else {
      // ATC selected - set flag to false
      setIsTC(false);
      // Fetch ATC details
      fetchATCDetails(atcId);
    }
    
    // Update stepData with the selected atcId
    setStepData((prev) => {
      const updatedData = {
        ...prev,
        inputTcDetails: {
          ...prev.inputTcDetails,
          selectedInputTcId: atcId
        }
      };
      return updatedData;
    });
  };

  // Handle data changes from child component (edits, selections)
  const handleProductDataChange = (updatedProducts: any[]) => {
    setAllProducts(updatedProducts);
  };

  const handleSelectionChange = (selectedIndices: number[]) => {
    // Convert indices to product IDs
    const selectedIds = selectedIndices.map(index => allProducts[index]?.productId).filter(Boolean);
    setSelectedProductIds(selectedIds);
  };
  const productInfoRef = useRef<any>(null);
  const lastProcessorInfoRef = useRef<any>(null);
  const additionalInfoRef = useRef<any>(null);
  const InfoRef = useRef<any>(null);
  const { notify } = useNotification();
  const formRefs = [
    InfoRef,
    productInfoRef,
    lastProcessorInfoRef,
  ];
  const navigate = useNavigate();

  const steps = [
    // {
    //   label: "Row Selection Demo",
    //   content: <SampleRowSelectionDemo />,
    // },
    {
      label: "OCS Processor",
      content: (
        <OcsProcessor
          ocsProcessorData={stepData.ocsProcessorConfig}
          setOcsProcessorData={(data) =>
            handleDataUpdate("ocsProcessorConfig", data)
          }
        />
      ),
    },
    {
      label: "Input TC Details",
      content: (
        <InputTcDetails
          formRef={productInfoRef}
          ocsProcessor={stepData.ocsProcessorConfig.tableData}
          inputData={stepData.inputTcDetails}
          setInputData={(data) => handleDataUpdate("inputTcDetails", data)}
          onTcIdSelection={handleTcIdSelection}
          onAtcIdSelection={handleAtcIdSelection}
          isTC={isTC}
        />
      ),
    },
    {
      label: "Product Details",
      content: (
        <CombinedProductDetails
          data={allProducts}
          selectedProductIds={selectedProductIds}
          onDataChange={handleProductDataChange}
          onSelectionChange={handleSelectionChange}
        />
      ),
    },
    {
      label: "Input TC Product Standard Details",
      content: (
        <InputTcProductStandardDetails
          productStandardData={stepData.inputTcProductStandardDetails}
          setProductStandardData={(data) =>
            handleDataUpdate("inputTcProductStandardDetails", data)
          }
          selectedInputTcId={selectedInputTcId}
          selectedProductIds={selectedProductIds}
          isTC={isTC}
        />
      ),
    },
    {
      label: "Raw Material Details",
      content: (
        <RawMaterialDetails
          rawMaterialInfoData={stepData.rawMaterialDetails}
          setRawMaterialInfoData={(data) =>
            handleDataUpdate("rawMaterialDetails", data)
          }
          selectedInputTcId={selectedInputTcId}
          selectedProductIds={selectedProductIds}
          isTC={isTC}
        />
      ),
    },
    {
      label: "Input Certified Raw Material",
      content: (
        <InputCertifiedRawMaterialDetails
          certifiedRawMaterialData={stepData.certifiedRawMaterialDetails}
          setCertifiedRawMaterialData={(data) =>
            handleDataUpdate("certifiedRawMaterialDetails", data)
          }
          inputTcDetails={stepData.inputTcDetails}
          rawMaterialInfoData={stepData.rawMaterialDetails}
          selectedProductIds={selectedProductIds}
          isTC={isTC}
        />
      ),
    }

  ];

  const handleNext = async () => {
    if (formRefs[activeStep]?.current) {
      // Prefer current form value for inputTcNo when determining if raw materials are mandatory
      const currentFormValues = formRefs[activeStep]?.current?.values || {};
      const isInputTcNoNA = (currentFormValues?.inputTcNo ?? stepData?.inputTcDetails?.inputTcNo) === "na";
      const errors = await formRefs[activeStep]?.current.validateForm();
      await formRefs[activeStep]?.current.submitForm();
      if (Object.keys(errors).length === 0) {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      } else {
        notify("Please Enter the Required Values", "error");
      }
    } else {
      // Step-specific validation logic
      if (activeStep === 0) {
        if (
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor == "N" &&
          stepData.ocsProcessorConfig.tableData.length > 0
        ) {
          stepData.ocsProcessorConfig.tableData = [];
        }
        // Validate ocsProcessorConfig for step 1
        if (
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor &&
          stepData?.ocsProcessorConfig?.inputTcOCSFirstProcessor == "Y"
        ) {
          if (
            stepData?.ocsProcessorConfig?.tableData &&
            Object.keys(stepData?.ocsProcessorConfig?.tableData).length > 0
          ) {
            setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
          } else {
            notify(
              "Please Enter the Required Values for OCS Processor",
              "error"
            );
          }
        } else {
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        }
      } else if (activeStep === 2) {
        // Validate Product Details step - check if there are selected products
        // Skip validation if no products are available to select
        if (allProducts.length === 0) {
          // No products available, skip validation and move to next step
          setStepData(prev => ({
            ...prev,
            combinedProductDetails: {
              ...prev.combinedProductDetails,
              products: [],
              selectedProductIds: []
            }
          }));
          
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else if (selectedProductIds.length > 0) {
          // Save selected products and their data to stepData
          const selectedProducts = allProducts.filter((product: any) => 
            selectedProductIds.includes(product.productId)
          );
          
          setStepData(prev => ({
            ...prev,
            combinedProductDetails: {
              ...prev.combinedProductDetails,
              products: selectedProducts,
              selectedProductIds: selectedProductIds
            }
          }));
          
          setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
        } else {
          notify("Please select at least one product from the table", "error");
        }
      } else {
        setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      }
      // else if (activeStep === 4) {
      //   // Validate inputTcProductStandardDetails for step 4
      //   if (
      //     stepData?.inputTcProductStandardDetails &&
      //     stepData?.inputTcProductStandardDetails.length > 0 &&
      //     stepData?.inputTcProductStandardDetails.every((item) => Object.keys(item).length > 0)
      //   ) {
      //     setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      //   } else {
      //     notify('Please Enter the Required Values for TC Product Standard Details', 'error');
      //   }
      // }
      // else {
      //   // Default behavior for steps without additional validation
      //   setActiveStep((prev) => Math.min(prev + 1, steps.length - 1)); // Move to the next step
      // }
    }
  };

  const mapToTCProductDetails = (jsonData: any): any => {
    const inputTcInfo = jsonData.inputTcInformation[0]; // First (and only) inputTcInformation object
    
    // Extract selectedProductIds and selectedInputTcId from the inputTcInformation level
    const selectedProductIds = inputTcInfo.selectedProductIds || [];
    const selectedInputTcId = inputTcInfo.selectedInputTcId || "";
    
    // Process ALL products from the API response
    const allProducts = inputTcInfo.inputTcProductInformation?.map((product: any, index: number) => ({
      id: product.productId || (index + 1).toString(),
      productId: product.productId || (index + 1).toString(),
      inputTcProductNo: product.inputTcProductNo,
      inputTcProductArticleNo: product.inputTcProductArticleNo,
      inputTcProductNumberOfUnits: product.inputTcProductNumberOfUnits,
      inputTcProductUnitsMetric: product.inputTcProductUnitsMetric,
      inputTcProductProductionDate: product.inputTcProductProductionDate,
      inputTcProductCategoryCode: product.inputTcProductCategoryCode,
      inputTcProductCategoryUserSpecificTerm: product.inputTcProductCategoryUserSpecificTerm,
      inputTcProductDetailCode: product.inputTcProductDetailCode,
      inputTcProductDetailUserSpecificTerm: product.inputTcProductDetailUserSpecificTerm,
      inputTcProductInfoTrimsExcluded: product.inputTcProductInfoTrimsExcluded,
      inputTcProductInfoAssociatedTc: product.inputTcProductInfoAssociatedTc,
      inputTcProductInfoFiberLength: product.inputTcProductInfoFiberLength || "",
      inputTcProductInfoYarnCount: product.inputTcProductInfoYarnCount || "",
      inputTcProductInfoFabricWeightAndConstruct: product.inputTcProductInfoFabricWeightAndConstruct || "",
      inputTcProductInfoFabricWeightOfFinishedProduct: product.inputTcProductInfoFabricWeightOfFinishedProduct || "",
      inputTcProductInfoAdditional: product.inputTcProductInfoAdditional,
    })) || [];
    
    // Filter products to only include selected ones
    const selectedProducts = allProducts.filter((product: any) => selectedProductIds.includes(product.productId));
    
    // Collect all standard details for selected products
    const allStandardDetails = selectedProducts.flatMap((product: any) => 
      inputTcInfo.inputTcProductInformation
        ?.find((p: any) => p.productId === product.productId)
        ?.inputTcProductStandardInformation?.map((stdInfo: any) => ({
          productNo: stdInfo.productNo,
          standard: "", // no separate standard value present in this source
          standardLabelGrade: stdInfo.inputTcProductStandardLabelGrade,
          certifiedWeight: stdInfo.inputTcProductCertifiedWeight?.toString() || "",
          certifiedWeightUsed: stdInfo.inputTcProductCertifiedWeightUsed?.toString() || "",
        })) || []
    ).filter((item: any) => (item.standard || "").toUpperCase() !== "GOTS");
    
    // Collect all raw material details for selected products
    const allRawMaterialDetails = selectedProducts.flatMap((product: any) => 
      inputTcInfo.inputTcProductInformation
        ?.find((p: any) => p.productId === product.productId)
        ?.inputProductRawMaterialInformation?.map((rawInfo: any) => ({
          tcProductNo: rawInfo.productNo,
          tcProductRawMaterialOrder: rawInfo.inputProductRawMaterialInformationOrder,
          tcProductRawMaterialCode: rawInfo.inputTcProductRawMaterialCode,
          tcProductRawMaterialPercentage: rawInfo.inputTcProductRawMaterialPercentage?.toString() || "",
        })) || []
    );
    
    // Check if inputTcNo starts with "ATU" - if so, it's an ATC number
    // Backend only sends one column: inputTcNo (can be TC or ATU/ATC)
    const backendNo = inputTcInfo.inputTcNo || "";
    
    let finalTcNo = "";
    let finalAtcNo = "";
    
    if (backendNo && (backendNo.toString().toUpperCase().startsWith("ATU") || backendNo.toString().toUpperCase().startsWith("GOTS"))) {
      // This is actually an ATC number
      finalAtcNo = backendNo;
    } else if (backendNo) {
      // This is a TC number
      finalTcNo = backendNo;
    }

    return {
      inputTcDetails: {
        inputTcNo: finalTcNo,
        inputAtcNo: finalAtcNo,
        inputTcSellerLicenseNo: inputTcInfo.inputTcSellerLicenseNo,
        inputTcSellerScNo: inputTcInfo.inputTcSellerScNo,
        inputTcSellerTeId: inputTcInfo.inputTcSellerTeId,
        inputTcUsdaCompliantFlag: inputTcInfo.inputTcUsdaCompliantFlag,
        tcAssociatedProductNo: inputTcInfo.tcAssociatedProductNo,
        InputCBLicensingCode: inputTcInfo.inputTcCbLicensingCode,
        selectedInputTcId: selectedInputTcId,
        selectedTcId: selectedInputTcId,
        selectedTcVersionNo: finalTcNo || finalAtcNo,
        inputTCFlag: inputTcInfo.inputTCFlag || "N",
      },

      combinedProductDetails: {
        inputTcProductNo: selectedProducts[0]?.inputTcProductNo || "",
        products: selectedProducts,
        selectedProductIds: selectedProductIds,
      },

      inputTcProductStandardDetails: allStandardDetails,
      rawMaterialDetails: allRawMaterialDetails,

      ocsProcessorConfig: {
        inputTcOCSFirstProcessor: inputTcInfo.ocsProcessor || "N",
        tableData: inputTcInfo.inputFarmTraderOrganicInformation.map(
          (item: any) => ({
            inputFarmSCNo: item.inputFarmScNo,
            inputFarmTCNo: item.inputFarmTcNo,
            inputTraderTCNoForOrganicMaterial:
              item.inputTraderTcNoForOrganicMaterial,
            inputTCOrganicFarmStandards: item.inputTcOrganicFarmStandards,
            tcProductRawMaterialOrder:
              item.inputFarmTraderOrganicInformationOrder,
          })
        ),
      },

      certifiedRawMaterialDetails: (inputTcInfo.inputTcCertifiedRawMaterialWeightUsedInformation || []).map((item: any) => ({
        inputTcCertifiedRawMaterialCode: item.inputTcCertifiedRawMaterialCode || "",
        outputTcCertifiedRawMaterialCode: item.outputTcCertifiedRawMaterialCode || "",
        inputTcCertifiedRawMaterialWeightUsed: item.inputTcCertifiedRawMaterialWeightUsed || 0,
        inputTcCertifiedRawMaterialCodeDescription: item.inputTcCertifiedRawMaterialCodeDescription || "",
        outputTcCertifiedRawMaterialCodeDescription: item.outputTcCertifiedRawMaterialCodeDescription || "",
      })),
    };
  };

  const handleBack = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
    setRestrictPopUpSave(false);
  };

  const handleFinish = async () => {
    if (TE_ID) {
      // Skip validation if TC/ATC is NOT applicable
      if (stepData.inputTcDetails.inputTCFlag === "N") {
        const payload = mapPayload(stepData, TE_ID, inputTcId,selectedProductIds,selectedInputTcId);
        
        // When TC/ATC is not applicable, directly save without checking product info
        if (inputTcId) {
          handleSave(payload);
        } else if (!inputTcId) {
          handleSave(payload);
        }
        return;
      }
      
      // Validate that at least 1 row of certified raw material data is present (only when TC/ATC IS applicable)
      if (!stepData.certifiedRawMaterialDetails || stepData.certifiedRawMaterialDetails.length === 0) {
        notify("Please add at least one certified raw material detail before saving", "error");
        return;
      }
      
      const payload = mapPayload(stepData, TE_ID, inputTcId,selectedProductIds,selectedInputTcId);

      // Check if we have valid product information before accessing it
      const hasValidProductInfo = 
        payload.inputTcInformation?.[0]?.inputTcProductInformation?.[0]?.inputTcProductNo;

      // Check if inputTcNo exists and has changed
      if (inputTcId) {
        // Find the existing record in tableData that matches the inputTcId
        const existingRecord = tableData.find(
          (item) => item.inputTcId === inputTcId
        );

        // If record exists and inputTcNo has changed, handle deletion
        if (
          existingRecord &&
          hasValidProductInfo &&
          existingRecord.inputTcProductNo !== hasValidProductInfo
        ) {
          const row = {
            original: {
              inputTcNo: hasValidProductInfo,
              inputTcId: inputTcId,
              shipmentId: shipmentId,
              productId: productId,
            },
          };
          const isAssociatedProductChanged =
            existingRecord &&
            !_.isEqual(
              existingRecord.tcAssociatedProductNo,
              payload.inputTcInformation[0].tcAssociatedProductNo
            );
          setIsValueChanged(isAssociatedProductChanged || false);
          await handleEditDelete(row);
          // The actual save will happen in the handleConfirmSave after deletion
          setPendingSave(payload);
          return;
        }

        // If it's a new component or no changes to component number, save directly
        handleSave(payload);
      } else if (!inputTcId) {
        // This is a new component, not an edit
        handleSave(payload);
      }
    }
  };

  const handleEdit = async (row: any) => {
    // Extract the component data from the row
    const value = row?.original;
    setShipmentId(value.shipmentId);
    setProductId(value.productId);
    setInputTcId(value.inputTcId);
    
    // Check if the TC ID (TE_ID) exists before fetching details
    if (TE_ID) {
      setIsEditLoading(true); // Start loading
      try {
        // Step 1: First fetch component details to get selectedInputTcId and selectedProductIds
        const componentData = await fetchProductComponentDetails(
          executeGet, // API executor function
          TE_ID, // tcId: using TE_ID
          value.shipmentId, // shipmentId from the component data
          value.productId, // productId from the component data
          value.inputTcId // inputTcId: mapping from componentId
        );
        
        
        const mappedStepData = mapToTCProductDetails(componentData.data);
        
        // Extract selectedInputTcId and selectedProductIds from the mapped data
        const selectedInputTcId = mappedStepData.inputTcDetails?.selectedInputTcId;
        const selectedProductIds = mappedStepData.combinedProductDetails?.selectedProductIds || [];
        
        // Determine if this is TC or ATC based on existing data
        const inputTcNo = mappedStepData.inputTcDetails?.inputTcNo;
        const inputAtcNo = mappedStepData.inputTcDetails?.inputAtcNo;
        const inputTCFlag = mappedStepData.inputTcDetails?.inputTCFlag;
        
        // Set isTC flag based on existing data
        let currentIsTC: boolean | null = null;
        if (inputAtcNo && inputAtcNo !== "" && inputAtcNo !== "na") {
          // ATC is selected
          currentIsTC = false;
          setIsTC(false);
        } else if (inputTcNo && inputTcNo !== "" && inputTcNo !== "na") {
          // TC is selected
          currentIsTC = true;
          setIsTC(true);
        } else {
          // Neither is selected - keep as null
          currentIsTC = null;
          setIsTC(null);
        }
        
        
        if (selectedInputTcId) {
          setSelectedInputTcId(selectedInputTcId);
        } else {
          const inputTcNo = mappedStepData.inputTcDetails?.inputTcNo;
          if (inputTcNo) {
            setSelectedInputTcId(inputTcNo);
          }
        }
        
        if (selectedProductIds.length > 0) {
          setSelectedProductIds(selectedProductIds);
        } else {
          setSelectedProductIds(["1"]);
        }
        
        // Step 2: Fetch all available products using selectedInputTcId
        const tcIdToUse = selectedInputTcId || mappedStepData.inputTcDetails?.inputTcNo || mappedStepData.inputTcDetails?.selectedInputTcId;
        
        // Don't call TC-related APIs if ATC is selected
        let allApiProducts = [];
        if (currentIsTC !== false) {
          const allProductsResponse = await fetchAllProducts(tcIdToUse);
          allApiProducts = mapApiResponseToTableData(allProductsResponse);
        } else {
          // For ATC flow, call the ATC details API to fetch fresh product data
          const atcIdToUse = selectedInputTcId || mappedStepData.inputTcDetails?.inputAtcNo;
          if (atcIdToUse && atcIdToUse !== "" && atcIdToUse !== "na") {
            try {
              const atcResponse: any = await executeATCGet(
                TCAppConfig.GET_ATC_DETAILS,
                { atcId: atcIdToUse }
              );
              
              if (atcResponse.data && atcResponse.data.productInformation) {
                // Map ATC product information to the expected format (skip units/metrics mapping for ATC source)
                allApiProducts = atcResponse.data.productInformation.map((product: any, index: number) => ({
                  id: `atc-product-${index}`,
                  productId: `atc-product-${index}`,
                  inputTcProductNo: product.atcProductNo || "",
                  inputTcProductArticleNo: "",
                  inputTcProductNumberOfUnits: null,
                  inputTcProductUnitsMetric: "",
                  inputTcProductProductionDate: "",
                  inputTcProductCategoryCode: product.atcProductCategoryCode || "",
                  inputTcProductCategoryUserSpecificTerm: "",
                  inputTcProductDetailCode: product.atcProductDetailCode || "",
                  inputTcProductDetailUserSpecificTerm: "",
                  inputTcProductInfoTrimsExcluded: "",
                  inputTcProductInfoAssociatedTc: "",
                  inputTcProductInfoFiberLength: "",
                  inputTcProductInfoYarnCount: "",
                  inputTcProductInfoFabricWeightAndConstruct: "",
                  inputTcProductInfoFabricWeightOfFinishedProduct: "",
                  inputTcProductInfoAdditional: "",
                }));
              } else {
                // Fallback to existing product data if ATC API fails
                allApiProducts = mappedStepData.combinedProductDetails?.products || [];
              }
            } catch (err) {
              console.error("Failed to fetch ATC details in edit flow:", err);
              // Fallback to existing product data if ATC API fails
              allApiProducts = mappedStepData.combinedProductDetails?.products || [];
            }
          } else {
            // No ATC ID available, use existing product data
            allApiProducts = mappedStepData.combinedProductDetails?.products || [];
          }
        }
        
        // Step 3: Match selectedProductIds with API product IDs and merge data
        const mergedProducts = allApiProducts.map((apiProduct: any) => {
          // Check if this API product is in the selectedProductIds
          const isSelected = selectedProductIds.includes(apiProduct.productId);
          
          if (isSelected) {
            // This product is selected, find its detailed data from component details
            const detailedProduct = mappedStepData.combinedProductDetails?.products?.find(
              (p: any) => p.productId === apiProduct.productId
            );
            
            // Merge API product (for correct ID) with detailed data from component details
            return {
              ...apiProduct, // Keep the correct productId from API
              id: apiProduct.productId, // Ensure ID matches productId
              // Override with detailed data from component details if available
              inputTcProductNo: detailedProduct?.inputTcProductNo || apiProduct.inputTcProductNo,
              inputTcProductArticleNo: detailedProduct?.inputTcProductArticleNo || apiProduct.inputTcProductArticleNo,
              inputTcProductNumberOfUnits: detailedProduct?.inputTcProductNumberOfUnits || apiProduct.inputTcProductNumberOfUnits,
              inputTcProductUnitsMetric: detailedProduct?.inputTcProductUnitsMetric || apiProduct.inputTcProductUnitsMetric,
              inputTcProductProductionDate: detailedProduct?.inputTcProductProductionDate || apiProduct.inputTcProductProductionDate,
              inputTcProductCategoryCode: detailedProduct?.inputTcProductCategoryCode || apiProduct.inputTcProductCategoryCode,
              inputTcProductCategoryUserSpecificTerm: detailedProduct?.inputTcProductCategoryUserSpecificTerm || apiProduct.inputTcProductCategoryUserSpecificTerm,
              inputTcProductDetailCode: detailedProduct?.inputTcProductDetailCode || apiProduct.inputTcProductDetailCode,
              inputTcProductDetailUserSpecificTerm: detailedProduct?.inputTcProductDetailUserSpecificTerm || apiProduct.inputTcProductDetailUserSpecificTerm,
              inputTcProductInfoTrimsExcluded: detailedProduct?.inputTcProductInfoTrimsExcluded || apiProduct.inputTcProductInfoTrimsExcluded,
              inputTcProductInfoAssociatedTc: detailedProduct?.inputTcProductInfoAssociatedTc || apiProduct.inputTcProductInfoAssociatedTc,
              inputTcProductInfoFiberLength: detailedProduct?.inputTcProductInfoFiberLength || apiProduct.inputTcProductInfoFiberLength,
              inputTcProductInfoYarnCount: detailedProduct?.inputTcProductInfoYarnCount || apiProduct.inputTcProductInfoYarnCount,
              inputTcProductInfoFabricWeightAndConstruct: detailedProduct?.inputTcProductInfoFabricWeightAndConstruct || apiProduct.inputTcProductInfoFabricWeightAndConstruct,
              inputTcProductInfoFabricWeightOfFinishedProduct: detailedProduct?.inputTcProductInfoFabricWeightOfFinishedProduct || apiProduct.inputTcProductInfoFabricWeightOfFinishedProduct,
              inputTcProductInfoAdditional: detailedProduct?.inputTcProductInfoAdditional || apiProduct.inputTcProductInfoAdditional,
            };
          } else {
            // This product is not selected, use API data as is
            return {
              ...apiProduct,
              id: apiProduct.productId, // Ensure ID matches productId
            };
          }
        });
        
        // Step 4: Set the merged products and selected IDs
        setAllProducts(mergedProducts);
        
        // For ATC flow, we need to ensure selectedProductIds match the new ATC product IDs
        if (currentIsTC === false && allApiProducts.length > 0) {
          // If we have ATC products, select all of them by default (similar to new ATC flow)
          const atcProductIds = allApiProducts.map((p: any) => p.productId);
          setSelectedProductIds(atcProductIds);
        } else {
          setSelectedProductIds(selectedProductIds);
        }
        
        // Update stepData with the merged products
        const finalSelectedProductIds = (currentIsTC === false && allApiProducts.length > 0) 
          ? allApiProducts.map((p: any) => p.productId)
          : selectedProductIds;
          
        const updatedStepData = {
          ...mappedStepData,
          combinedProductDetails: {
            ...mappedStepData.combinedProductDetails,
            products: mergedProducts.filter((p: any) => finalSelectedProductIds.includes(p.productId)),
            selectedProductIds: finalSelectedProductIds
          }
        };
        
        setStepData(updatedStepData);
        
        toggleDrawer();
        setIsEditLoading(false); // Stop loading after drawer opens
        
      } catch (err: any) {
        console.error('Error in edit flow:', err);
        notify(err?.message || 'An error occurred', "error");
        setIsEditLoading(false); // Stop loading on error
      }
    }

    // Update additional state for editing context
    setEditingIndex(row.index);
    setZustandInitialState(value);
  };

  const handleDelete = (row: any) => {
    setInputTcId(row?.original?.inputTcId);
    setShipmentId(row?.original?.shipmentId);
    setProductId(row?.original?.productId);

    setDialogOpen(true);
    setPopUpBtnName("Delete");
    setPopUpTitle("Confirm Delete ?");
    setPopUpMessage(
      `Deleting a Product will remove all the Associated Records, are you sure want to delete it`
    );
  };
  const handleEditDelete = (row: any) => {
    setInputTcId(row?.original?.inputTcId);
    setShipmentId(row?.original?.shipmentId);
    setProductId(row?.original?.productId);

    setDialogOpen(true);
    setPopUpBtnName("Save");
    setPopUpTitle("Confirm Save");
    setPopUpMessage(
      `Editing a Product No. will remove all the Associated Records, are you sure you want to edit it?`
    );
  };

  const certifiedWeightCell = ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as any;
    if (weightUsed?.length > 1) {
      const formattedVals = weightUsed.map((num: any) => {
        if (!isNaN(parseFloat(num)) && isFinite(Number(num))) {
          return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }).format(Number(num));
        }
        return num;
      });
      const result = formattedVals.join(", ");
      return result;
    } else {
      if (!isNaN(parseFloat(weightUsed)) && parseFloat(weightUsed) > 0) {
        return new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(parseFloat(weightUsed));
      }
      return weightUsed;
    }
  };

  const columns: MRT_ColumnDef<any>[] = [
    {
      accessorKey: "inputTcNo",
      header: "Input TC No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "tcAssociatedProductNo",
      header: "Associated Product No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerLicenseNo",
      header: "Seller License No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerScNo",
      header: "Seller SC No.",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcSellerTeId",
      header: "Input TC Seller TE-ID",
      minSize: 60,
      maxSize: 100,
    },
    {
      accessorKey: "inputTcUsdaCompliantFlag",
      header: "USDA Compliance",
      minSize: 60,
      maxSize: 100,
    }
  ];

  const onNext = () => {
    navigate(`/tc/${formtype}/Input-tc-component/${TE_ID}`);
  };

  const handleSave = async (payload: any) => {
    if (!TE_ID) {
      return;
    }
    const paramData = getProductShipmentDataByProductNo(
      productData,
      payload.inputTcInformation[0].tcAssociatedProductNo
    );
    const queryParams = new URLSearchParams({
      tcId: TE_ID,
      shipmentId: JSON.stringify(paramData?.shipmentId) || "",
      productId: paramData?.productId || "",
    }).toString();

    const oldProductIdArray = productId ? productId : paramData?.productId;
    const oldShipmentIdArray = shipmentId
      ? [shipmentId]
      : paramData?.shipmentId;
    const oldProductIdParam = JSON.stringify(oldProductIdArray);
    const oldShipmentIdParam = JSON.stringify(oldShipmentIdArray);

    const finalUrl = `${TCAppConfig.INPUT_TCPRODUCT_DETAILS_ENDPOINT}?${queryParams}&oldProductId=${oldProductIdArray}&oldShipmentId=${oldShipmentIdParam}`;

    const result: any = await executePost(finalUrl, payload);
    if (result.status == 200) {
      notify("Data Saved Successfully", "success");
      setInputTcId("");
      setShipmentId("");
      setProductId("");
      setAllProducts([]);
      setSelectedProductIds([]);
      setSelectedInputTcId("");
      fetchInputTcProductDetails();
      setStepData({
        inputTcDetails: initInputTcDetails,
        combinedProductDetails: {
          inputTcProductNo: "",
          products: [],
          selectedProductIds: []
        },
        inputTcProductStandardDetails: initInputTcProductStandardDetails,
        rawMaterialDetails: initRawMaterialInfo,
        certifiedRawMaterialDetails: initCertifiedRawMaterialDetails,
        ocsProcessorConfig: initocsProcessorConfig,
      });

      toggleDrawer();
      await onNextTab();
    } else {
      notify("Unable to Save", "error");
    }
  };
  const handleCancelSave = () => {
    setDialogOpen(false);
    if (drawerOpen) {
      toggleDrawer();
    }
  };

  const actions: ActionButtonConfig[] = [
    ...activeStep!==0?[{
      label: "Back",
      onClick: handleBack,
      variant: "contained" as "contained",
      color: "default" as "default",
      disabled: activeStep === 0,
    }]:[],
    {
      label: activeStep === steps.length - 1 ? "Save" : "Next",
      onClick: activeStep === steps.length - 1 ? handleFinish : handleNext,
      variant: "contained" as "contained",
      color: "primary" as "primary",
      disabled: activeStep === 0 ||activeStep === 1 || activeStep===3 || activeStep===4 ? isRestrictPopUpSave : false,
    },
  ];
  return (
    <>
      {loading || isEditLoading ? (
        <LoaderComponent />
      ) : (
        <>
          <Box display="flex" mb={3} justifyContent="flex-end" width="100%">
            {!hasSubmitTC && (
              <StyledButton variant="contained" onClick={toggleDrawer}>
                Add Input TC Details
              </StyledButton>
            )}
          </Box>
          <Box display="grid">
            <CustomTable
              columns={columns}
              data={tableData}
              rowCount={rowCount}
              paginations={pagination}
              setPaginations={setPagination}
              enableTopToolbar={false}
              enableBottomToolbar={true}
              enableRowActions={!hasSubmitTC}
              renderRowActions={({ row }) => (
                <ActionsMenu
                  row={row}
                  onEdit={handleEdit}
                  onDelete={handleDelete}
                />
              )}
              renderDetailPanel={({ row }) =>
                // Only mount the detail panel if the row is expanded
                row.getIsExpanded() ? (
                  <RenderDetailPanel row={row} />
                ) : (
                  <>NO data</>
                )
              }
            />
          </Box>
          <ActionsModalPopup
            open={drawerOpen}
            onClose={toggleDrawer}
            title="Input TC Product Details"
            actions={actions}
          >
            <CustomStepper
              steps={steps}
              activeStep={activeStep}
              onStepChange={(step) => setActiveStep(step)}
            />
          </ActionsModalPopup>
          {!drawerOpen ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
                gap: "0.5rem",
              }}
            >
              <NavLink to="/tc-dashboard">
                <InnerButton>Home</InnerButton>
              </NavLink>
              {/* {!isNextEnabled && <InnerButton onClick={handleSave}>Save & Next</InnerButton>= */}
              {tableData?.length > 0 && isNextEnabled && (
                <InnerButton onClick={onNext}>Next</InnerButton>
              )}
            </Box>
          ) : (
            <>
              {hasSubmitTC && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 2,
                    gap: "0.5rem",
                  }}
                >
                  <NavLink to={`/tc/${formtype}/component-details/${TE_ID}`}>
                    <InnerButton>Back</InnerButton>
                  </NavLink>
                  <InnerButton onClick={onNext}>Next</InnerButton>
                </Box>
              )}
            </>
          )}

          <AlertPopup
            open={dialogOpen}
            title={popUpTitle}
            message={popUpMessage}
            onClose={handleCancelSave}
            onConfirm={handleConfirmSave}
            confirmText={popUpBtnName}
            cancelText="Cancel"
          />
        </>
      )}
    </>
  );
};

export default InputTcProductDetail;


